import api from './Api'

export const getNickNameWeb = () => {
    return api.get<string>(`/nickname/web`);
}

export const getNickNameDetailWeb = () => {
    return api.get<INickNameWebResponseForDetail>(`/nickname/detail/web`);
}
export const createOrUpdateNickNameWeb = (createOrUpdateNickNameWebRequest: ICreateOrUpdateNickNameWebRequest) => {
    return api.patch<boolean>(`/nickname/web`, createOrUpdateNickNameWebRequest);
}


export const createNickNameWeb = (nickName: string) => {
    return api.post<boolean>(`/nickname/web`, { nickName });
}

export const existByNickName = (nickname: string) => {
    return api.get<boolean>(`/nickname/exist/web/${nickname}`);
}